export default __webpack_public_path__ + "static/media/charterhouseclaims.95e1eeee.png";